const DEFAULT_MAP_QUERY = "Samsun Yalı Özel Erkek Öğrenci Yurdu";
const DEFAULT_GOOGLE_BUSINESS_URL = "https://share.google/HFON57ZJr0ir2TVmy";

export const getMapEmbedUrl = (content = {}) => {
  const query = content.map_query || content.map_address || DEFAULT_MAP_QUERY;
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
};

export const getMapDirectionsUrl = (content = {}) =>
  content.map_business_url || DEFAULT_GOOGLE_BUSINESS_URL;
